var M = (t, e, o) => {
  if (!e.has(t))
    throw TypeError("Cannot " + o);
};
var L = (t, e, o) => (M(t, e, "read from private field"), o ? o.call(t) : e.get(t)), R = (t, e, o) => {
  if (e.has(t))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(t) : e.set(t, o);
}, S = (t, e, o, r) => (M(t, e, "write to private field"), r ? r.call(t, o) : e.set(t, o), o);
function q(t) {
  return k(t) && t.nodeType == Node.ELEMENT_NODE;
}
function k(t) {
  return !!t && "nodeType" in t;
}
function x(t, e) {
  const o = e.createElement("template");
  o.innerHTML = t;
  const r = o.content;
  return r.normalize(), r;
}
const P = {
  componentTagName: "react-component",
  slotTagName: "react-slot",
  nameAttribute: "name",
  propsAttribute: "props"
};
function _(t, e, o) {
  const { componentTagName: r, nameAttribute: s } = Object.assign({}, P, o), y = t.querySelectorAll(r), c = new Set(
    Array.from(y).map((i) => {
      const u = i.getAttribute(s);
      if (!u)
        throw new Error(`Missing "${s}" attribute on <${r}>`);
      return u;
    })
  );
  return e([...c]);
}
const z = {
  ...P,
  fragmentTagName: "react-fragment",
  loadingClassName: "loading"
}, N = /* @__PURE__ */ new Map();
function U(t) {
  let e = N.get(t) ?? null;
  return e != null && e.isConnected ? e : (e = document.querySelector(`body > #${t}`), e != null && e.isConnected ? (N.set(t, e), e) : (e = document.createElement("div"), e.id = t, document.body.appendChild(e), N.set(t, e), e));
}
function O(t, e) {
  const o = t instanceof Element ? t : U("react-root"), r = t instanceof Element ? e : t, { loader: s, manifest: y } = r;
  let c = !1, i = /* @__PURE__ */ new Map();
  const u = /* @__PURE__ */ new Map(), h = /* @__PURE__ */ new Set(), E = Object.assign({}, y), f = Object.assign({}, z, r.schema), w = () => {
    c || (i.forEach((n, a) => {
      a.isConnected || (i.delete(a), u.delete(a));
    }), i = new Map(i), h.forEach((n) => n()));
  }, v = async (n, a, d) => {
    const l = typeof a == "string" ? x(a, n.ownerDocument) : a;
    if (q(l) && l.tagName.toLowerCase() != f.fragmentTagName)
      throw new Error("Cannot rerender with a non-fragment element");
    await _(l, (m) => W(m, s, E), f);
    const p = T(l, E, f);
    d && (n.innerHTML = ""), i.set(n, p), w(), n.classList.remove(f.loadingClassName), n.classList.length == 0 && n.removeAttribute("class");
  }, B = (n) => {
    const a = new MutationObserver((d) => {
      const p = d.flatMap((m) => Array.from(m.removedNodes)).find((m) => m == n);
      p && !p.isConnected && (u.delete(n), i.delete(n), a.disconnect(), w());
    });
    a.observe(n.parentNode, { childList: !0 });
  }, A = async (n) => {
    !c && !u.has(n) && (await C, u.set(n, (a) => v(n, a, !1)), B(n), await v(n, n, !0));
  }, D = () => i, F = (n) => (c || h.add(n), () => {
    h.delete(n);
  });
  let C, b, T;
  const $ = async () => {
    if (c)
      throw new Error("Root is destroyed");
    let n = () => {
    };
    const a = new Promise((j) => {
      n = j;
    }), [
      { createAndRenderReactRoot: d, hydrate: l },
      p,
      m
    ] = await Promise.all([
      import("./root.react-WmAMWilf.js"),
      G(s, r.layoutComponentName),
      I(s, r.errorBoundaryFallbackComponentName)
    ]);
    T = l, b = d({
      container: o,
      subscribe: F,
      getSnapshot: D,
      onMounted: n,
      LayoutComponent: p,
      ErrorBoundaryFallbackComponent: m
    }), await a;
  };
  return {
    render(n, a) {
      if (a) {
        const d = u.get(n);
        if (d)
          return { count: 1, done: d(a) };
      } else {
        if (C || (C = $()), n.tagName.toLowerCase() == f.fragmentTagName)
          return { count: 1, done: A(n) };
        {
          const d = Array.from(n.querySelectorAll(f.fragmentTagName));
          if (d.length)
            return {
              count: d.length,
              done: Promise.all(d.map(A)).then(() => {
              })
            };
        }
      }
      return { count: 0, done: Promise.resolve() };
    },
    remove(n) {
      return u.has(n) ? (u.delete(n), i.delete(n), w(), !0) : !1;
    },
    contains(n) {
      return n.tagName.toLowerCase() != f.fragmentTagName && !!n.closest(f.fragmentTagName);
    },
    destroy() {
      c = !0, i.clear(), w(), h.clear(), b == null || b(), u.clear(), o.remove(), N.clear();
    },
    getCache() {
      return i;
    }
  };
}
async function W(t, e, o) {
  return await Promise.all(
    t.filter((r) => !o[r]).map(
      (r) => e(r).then((s) => {
        o[r] = s;
      })
    )
  ), o;
}
async function G(t, e) {
  if (e)
    return await t(e);
}
async function I(t, e) {
  if (e)
    return await t(e);
}
function Q(t) {
  const e = /* @__PURE__ */ new Set();
  return {
    init(o) {
      let r;
      const s = new Promise((c) => {
        r = c;
      });
      e.add(s), (async () => {
        const c = t.render(o);
        c.count != 0 && await c.done;
      })().then(() => {
        e.delete(s), r();
      });
    },
    async ready() {
      await Promise.all([...e]);
    },
    validate(o) {
      if (t.contains("body" in o ? o.body : o))
        throw new Error("Cannot apply actions inside fragment");
    },
    onCreateElement(o) {
      const r = t.render(o);
      return r.count == 0 ? !1 : (e.add(r.done), r.done.then(() => e.delete(r.done)), !0);
    },
    onBeforeUpdateElement(o, r) {
      const s = t.render(o, r);
      return s.count == 0 ? !1 : (e.add(s.done), s.done.then(() => e.delete(s.done)), !0);
    },
    onBeforeDestroyElement(o) {
      return t.remove(o);
    }
  };
}
var g;
class V {
  /**
   * The provided function should receive an observer and connect that
   * observer's `next` method to an event source (for instance,
   * `element.addEventListener('click', observer.next)`).
   *
   * It must return a function that will disconnect the observer from the event
   * source.
   */
  constructor(e) {
    R(this, g, void 0);
    S(this, g, e);
  }
  /**
   * `subscribe` uses the function supplied to the constructor to connect an
   * observer to an event source.  Each observer is connected independently:
   * each call to `subscribe` calls `connect` with the new observer.
   *
   * To disconnect the observer from the event source, call `unsubscribe` on the
   * returned subscription.
   *
   * Note: `subscribe` accepts either a function or an object with a
   * next method.
   */
  subscribe(e) {
    const o = J(e);
    let r = L(this, g).call(this, o);
    return {
      unsubscribe() {
        r && (r(), r = void 0);
      }
    };
  }
}
g = new WeakMap();
function J(t) {
  return typeof t == "function" ? { next: t } : t;
}
export {
  V as O,
  z as a,
  Q as b,
  O as c,
  P as d,
  U as f,
  _ as p
};
